(function () {
  var SECTION_ID = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var refreshing = false;

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function getPanel() {
    var drawer = getDrawer();
    return drawer ? drawer.querySelector('[data-cart-drawer-panel]') : null;
  }

  function isOpen() {
    var drawer = getDrawer();
    return drawer && drawer.classList.contains('is-open');
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.hidden = false;
    /* Force reflow so the open transition always plays */
    void drawer.offsetWidth;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('saha-drawer-open');

    var panel = getPanel();
    if (!panel) return;
    var focusable = panel.querySelector(
      'button:not([disabled]), a[href], input:not([disabled])'
    );
    if (focusable) focusable.focus();
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('saha-drawer-open');
    window.setTimeout(function () {
      var d = getDrawer();
      if (d && !d.classList.contains('is-open')) d.hidden = true;
    }, 320);

    var trigger = document.querySelector('[data-cart-drawer-open]');
    if (trigger) trigger.focus();
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count <= 0;
    });
  }

  function refreshDrawer(keepOpen) {
    if (refreshing) return Promise.resolve();
    refreshing = true;
    var shouldStayOpen = keepOpen || isOpen();

    return fetch(root + '?section_id=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshSection = doc.getElementById('shopify-section-' + SECTION_ID);
        var currentSection = document.getElementById('shopify-section-' + SECTION_ID);
        if (!freshSection || !currentSection) return;

        var freshDrawer = freshSection.querySelector('[data-cart-drawer]') || freshSection;
        var currentDrawer = currentSection.querySelector('[data-cart-drawer]');

        /* Replace only the drawer contents, keep the live open state on the root */
        if (currentDrawer && freshDrawer) {
          currentDrawer.innerHTML = freshDrawer.innerHTML;
        } else {
          currentSection.innerHTML = freshSection.innerHTML;
        }

        if (shouldStayOpen) {
          openDrawer();
        }

        return fetch(root + 'cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateHeaderCount(cart.item_count);
          });
      })
      .finally(function () {
        refreshing = false;
      });
  }

  function changeQuantity(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function () { return refreshDrawer(true); });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
      refreshDrawer(true);
      return;
    }

    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var dec = e.target.closest('[data-cart-qty-decrease]');
    var inc = e.target.closest('[data-cart-qty-increase]');
    if (dec || inc) {
      var row = e.target.closest('[data-cart-item]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var input = row.querySelector('[data-cart-qty-input]');
      if (!key || !input) return;
      var qty = parseInt(input.value, 10) || 0;
      qty = dec ? Math.max(0, qty - 1) : qty + 1;
      input.value = qty;
      changeQuantity(key, qty);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    var row = input.closest('[data-cart-item]');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    changeQuantity(key, qty);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeDrawer();
  });

  document.querySelectorAll('[data-product-form]').forEach(function (wrap) {
    var form = wrap.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submit = form.querySelector('[name="add"]');
      if (submit) submit.disabled = true;

      fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function () {
          return refreshDrawer(true).then(openDrawer);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.disabled = false;
        });
    });
  });
})();
